module.exports = __webpack_public_path__ + "static/media/2_AP_Moderate_Z1.443fdb8d.png";